import { ActionReducerMap, createFeatureSelector, createSelector } from '@ngrx/store';
import Debug from 'debug';
import * as fromGroupsReducer from './groups.reducer';
import * as fromTemplatesReducer from './templates.reducer';

const debug = Debug('aumico:aumico-lib-templates-fe:AumicoTemplatesReducer');

export const aumicoTemplatesFeatureKey = 'aumicoTemplates';

export interface FeatureState {
    groups: fromGroupsReducer.GroupState;
    templates: fromTemplatesReducer.TemplateState;
}
export interface AppState {
    aumicoTemplates: FeatureState;
}
export const reducers: ActionReducerMap<FeatureState> = {
    groups: fromGroupsReducer.reducer,
    templates: fromTemplatesReducer.reducer,
};
export const selectFeature = createFeatureSelector<FeatureState>(aumicoTemplatesFeatureKey);

//Groups
export const selectGroupState = createSelector(selectFeature, (state: FeatureState) => state.groups);
export const selectAllGroups = createSelector(selectGroupState, fromGroupsReducer.selectAllGroups);
export const selectGroups = createSelector(selectGroupState, fromGroupsReducer.selectGroups);
export const selectDefaultGroups = createSelector(selectGroupState, fromGroupsReducer.selectDefaultGroups);
export const selectActiveGroup = createSelector(selectGroupState, fromGroupsReducer.getActiveGroup);
export const selectGroupsResponse = createSelector(selectGroupState, fromGroupsReducer.getGroupsResponse);
export const selectGroupsError = createSelector(selectGroupState, fromGroupsReducer.getGroupsError);
export const selectGroupsTranslations = createSelector(selectGroupState, fromGroupsReducer.getTranslations);
export const selectGroupNameExists = createSelector(selectGroupState, fromGroupsReducer.getGroupNameExists);
export const selectEquityGroupOptions = createSelector(selectGroupState, fromGroupsReducer.getEquityGroupOptions);

//Templates
export const selectTemplateState = createSelector(selectFeature, (state: FeatureState) => state.templates);
export const selectAllTemplates = createSelector(selectTemplateState, fromTemplatesReducer.selectAllTemplates);
export const selectTemplateByLegalFormAndAccountBasis = createSelector(
    selectTemplateState,
    fromTemplatesReducer.getTemplateByLegalFormAndAccountBasis,
);
export const selectActiveTemplate = createSelector(selectTemplateState, fromTemplatesReducer.getActiveTemplate);
export const selectActiveTemplateType = createSelector(selectTemplateState, fromTemplatesReducer.getActiveTemplateType);
export const selectTemplatesResponse = createSelector(selectTemplateState, fromTemplatesReducer.getTemplatesResponse);
export const selectTemplatesError = createSelector(selectTemplateState, fromTemplatesReducer.getTemplatesError);
export const selectTemplateNameExists = createSelector(selectTemplateState, fromTemplatesReducer.getTemplateNameExists);
export const selectTemplateAccountBasisAndLegalFormExists = createSelector(
    selectTemplateState,
    fromTemplatesReducer.getTemplateAccountBasisAndLegalFormExists,
);
export const selectSubTotalNameExists = createSelector(selectTemplateState, fromTemplatesReducer.getSubtotalNameExists);
export const selectFinancialLineItems = createSelector(selectTemplateState, fromTemplatesReducer.getFinancialLineItems);
export const selectCashAndProfitOptions = createSelector(
    selectTemplateState,
    fromTemplatesReducer.getCashAndProfitOptions,
);

export const SelectAllTemplatesNamesAndIdsByTemplateType = createSelector(
    selectTemplateState,
    fromTemplatesReducer.getAllTemplatesNamesAndIdsByTemplateType,
);
export const selectAllAccounts = createSelector(selectTemplateState, fromTemplatesReducer.getAllAccounts);
